var map = {
	"./Aorta.png": 204,
	"./Bone.png": 205,
	"./Brain.png": 206,
	"./Breast-Chest.png": 207,
	"./Breast.png": 208,
	"./Colon.png": 209,
	"./Covid.png": 210,
	"./Eye.png": 211,
	"./Figure-outside-body-walking.png": 212,
	"./Genitalia.png": 213,
	"./Heart.png": 214,
	"./Hip.png": 215,
	"./Kidney.png": 216,
	"./Liver.png": 217,
	"./Lung.png": 218,
	"./Mouth.png": 219,
	"./Needle-in-arm.png": 220,
	"./Pancreas.png": 221,
	"./Physical-Exam.png": 222,
	"./Stomach.png": 223,
	"./Sun.png": 224,
	"./bp.png": 225,
	"./braingear.png": 226,
	"./defaultIcon.png": 145,
	"./familydoctor.png": 227,
	"./money.png": 228,
	"./sleep.png": 229,
	"./symptomchecker.png": 230
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 144;